<template>
  <div class="workspace">
    <TopHeader />
    <Navi />
    <fluidCover />
    <fluidBend />
    <div class="wrapper">
      <TaskContainer>
        <template v-slot:sidebar>
          <LectureFilter v-if="loc == 1" />
          <LectureFilter v-if="loc == 4" />
        </template>
        <template v-slot:mbody>
          <LectureList v-if="loc == 1" />
          <LectureDetail v-if="loc == 4" />

          <LessonList v-if="loc == 2" />
          <CompLesson v-if="loc == 3" />
        </template>
      </TaskContainer>
    </div>
  </div>
</template>



<script>
import TopHeader from "@/components/Header";
import Navi from "@/components/Navi";
import FluidCover from "@/components/FluidCover";
import FluidBend from "@/components/FluidBend";
import LectureList from "@/components/LectureList";
import LessonList from "@/components/LessonList";
import LectureDetail from "@/components/LectureDetail";

import TaskContainer from "@/components/TaskContainer";
import LectureFilter from "@/components/LectureFilter";
import CompLesson from "@/components/CompLesson";
export default {
  components: {
    TopHeader,
    Navi,
    FluidCover,
    FluidBend,
    LectureList,
    TaskContainer,
    LessonList,
    LectureFilter,
    CompLesson,
    LectureDetail,
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        let mode = to.query.mode;

        if (mode != undefined) {
          this.$store.state.loc = mode;
        } else {
          this.$store.state.loc = 1;
        }
      },
    },
  },

  computed: {
    loc() {
      return this.$store.state.loc;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.wrapper {
  margin: auto;
  max-width: 1200px;
  margin-bottom: 25px;
}
</style>